<template lang="pug">
  .root
    the-heading(:caption="'Журнал запросов'" :breadcrumbs="breadcrumbs")
    .container
      .main_block
        .globalCaptionStyles.localCaption Журнал запросов
        .filter_block
          Keypress(:key-code="13" event="keyup" @pressed="find")
          .fields
            .item
              label ID
              .field_container
                WebiomedInput(v-model="filter.id__icontains" :value="filter.id__icontains ")
            .item
              label Время запроса больше, чем (в мс)
              .field_container
                WebiomedInput(v-model="filter.response_time__gt" :value="filter.response_time__gt")
            .item
              label Код запроса
              .field_container
                WebiomedInput(v-model="filter.status_code" :value="filter.status_code")
            .item
              label Раздел
              .field_container
                WebiomedSelect(:options="permissionOptions" :value="filter.path__icontains" v-model="filter.path__icontains")
            .item
              label Метод
              .field_container
                WebiomedSelect(:options="methodsOptions" :value="filter.method" v-model="filter.method")
            .item
              label Статус запроса
              .field_container
                WebiomedSelect(:options="statusOptions" :value="filter.status_code__range" v-model="filter.status_code__range")
            .item
              label Клиент
              .field_container
                WebiomedInput(v-model="filter.remote_addr" :value="filter.remote_addr")
            .item
              label Логин пользователя
              .field_container
                WebiomedSearchField(
                  v-model="filter.user"
                  :value="filter.user"
                  :search_by="'id'",
                  :show="'username'"
                  :api="'gate/api/v1/'"
                  :address="'accounts/'"
                  :fieldAdd="'?username__icontains='"
                  :placeholder="'Введите имя учётной записи...'"
                  :icons="'clinic-medical'",
                  :namespase="'RequestsLogs'"
                )
            .item
              label Совершён c
              .field_container
                WebiomedDatepicker(v-model="filter.requested_at__gt" :value="filter.requested_at__gt")
            .item
              label Совершён по
              .field_container
                WebiomedDatepicker(v-model="filter.requested_at__lt" :value="filter.requested_at__lt")

          .buttons
            button.find(@click="find") Найти
            button.clear(@click="clear") Очистить фильтры
            //- v-icon(name="notes-medical sx")
            div(style="display: inline-block; margin-left: 5px") Количество записей:
            span(style="font-weight: bold") {{' ' +count}}

        page-grid(:cols="cols" ref="grid" :response="data" :nextState="nextState" :count="count" :iconFiels="iconFiels")
</template>
<script>
import TheHeading from '@/components/parts/TheHeading'
import WebiomedInput from '@/components/fields/WebiomedInput'
import WebiomedDatepicker from '@/components/fields/WebiomedDatepicker'
import WebiomedSearchField from '@/components/fields/WebiomedSearchField'
import WebiomedSelect from '@/components/fields/WebiomedSelect'
import methodsOptions from '@/data/options/methods'
import statusOptions from '@/data/options/requestStatus'
import permissionOptions from '@/data/options/permissions'
import PageGrid from '../parts/PageGrid'
import pageGridMixin from '@/mixins/pageGridMixin'
import breadcrumbs from '@/data/breadcrumbs/NSI'
import cols from '@/data/cols/requestLogs'
import Icon from 'vue-awesome/components/Icon'

export default {
  components: {
    PageGrid,
    TheHeading,
    WebiomedInput,
    WebiomedDatepicker,
    WebiomedSearchField,
    WebiomedSelect,
    'v-icon': Icon,
    breadcrumbs,
    Keypress: () => import('vue-keypress')
  },
  mixins: [pageGridMixin],
  data () {
    return {
      address: 'monitoring/request-log/?',
      api: 'dhra/api/v2/',
      breadcrumbs,
      cols,
      methodsOptions,
      statusOptions,
      permissionOptions,
      nextState: 'LogSummary',
      iconFiels: {
        key: 'status_code',
        iconName: 'exclamation-circle',
        getClass: str => {
          if (str >= 500) return 'red'
          else if (str >= 400 && str < 500) return 'yellow'
          else if (str >= 200 && str < 300) return 'green'
          else return 'gray'
        }
      }
    }
  },
  created () {
    if (this.$route.query) {
      for (let key in this.$route.query) {
        if (key !== 'path__icontains' && key !== 'method' && key !== 'status_code__range') this.filter[key] = this.$route.query[key]
      }
    }
    localStorage.removeItem('sParams')
  },
  methods: {
    setData (response) {
      this.data = response.map(item => {
        return {
          id: item.id,
          remote_addr: item.remote_addr,
          method: item.method,
          path: item.path,
          response_time: item.response_time + ' мс',
          status_code: item.status_code,
          requested_at: this.$moment(item.requested_at).format('DD MMMM YYYY, HH:mm:ss'),
          username: item.username || item.user
        }
      })
    }
  }
}
</script>
<style lang="sass" scoped>
@import "@/css/pageGridStyles.sass"
.RequestsLogs
  font-size: 15px
  height: 62px
@media screen and (max-width: 1460px)
  .fields
    grid-template-columns: 1fr 1fr
@media screen and (max-width: 1000px)
  .fields
    grid-template-columns: 1fr
    width: 95vw
    justify-content: center
</style>
